
$(document).ready(function() {
  // Hero section
  // $('.bm-hero-section').insertBefore('.main-content');
  
  // Product carousel
  $('.section-store .t--section-title:contains("Carousel")').parents('.section-store').addClass('bm-product-carousel');
  $('.section-store .t--section-title:contains("Carousel")').remove();
  
  $('.bm-product-carousel .store').prepend('<div class="bmstore_section"><div class="bm-store-wraper"></div></div>');
  $('.bm-product-carousel .product__title a').each(function() {
    var productName = '';
    var productNameArray = $(this).text().split(' ');
    if (productNameArray.length > 1) {
      productName = productNameArray[1];
      var title = '<h2 class="t--section-title bmstore_heading text-align--center f--main font-size--l lg--font-size--xl m0 mb3 bm-' + productName.toLowerCase() + '"><span>' + productName.toUpperCase() + ' ALT</span></h2>';
      $('.bmstore_section .bm-store-wraper').append(title);
    }
    
    var productTitle = $(this).text().replace('Ritual', '');
    $(this).parents('.product-single').find('.product-single__media').append('<div class="bm-product-title">' + productTitle + '</div>');
    
    var href = $(this).attr('href');
    $(this).parents('.product-single').find('hr.rule').before('<div class="bm-learn-more bm-learn-more-' + productName.toLowerCase() + '"><a href="' + href + '" class="btn global__shop_button">Learn More</a></div>');
  });
  
  var bmQuantity = '' +
    '  <div class="bm-quantity">' +
    '      <select>' +
    '          <option value="1">1</option>' +
    '          <option value="2">2</option>' +
    '          <option value="3">3</option>' +
    '          <option value="4">4</option>' +
    '          <option value="5">5</option>' +
    '          <option value="6">6</option>' +
    '          <option value="7">7</option>' +
    '          <option value="8">8</option>' +
    '          <option value="9">9</option>' +
    '          <option value="10">10</option>' +
    '      </select>' +
    '  </div>';
  $('.bm-product-carousel .cta-content').prepend(bmQuantity);
  
  $('body').on('change', '.bm-quantity select', function() {
    $(this).parents('.product-single').find('input[name="quantity"]').val($(this).val());
  });
  
  $('.bmstore_section .bm-store-wraper h2:first-child').addClass('bm-active');
  
  var bmSlides = $('.shopify-section.section-store:not(.bm-section-store) .store>.wrapper.section--wrapper>.single-product').length;
  $('.bm-product-carousel  .wrapper.section--wrapper').slick({
    centerMode: true,
    centerPadding: '0px',
    slidesToShow: bmSlides,
    slidesToScroll: bmSlides,
    infinite: false,
    responsive: [{
      breakpoint: 767,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '32px',
        slidesToShow: 1
      }
    }]
  });
  
  $('.bm-store-wraper>h2').click(function(e) {
    $('.bm-product-carousel  .wrapper.section--wrapper').slick('slickGoTo', $(this).index());
    $('.bm-store-wraper>h2').removeClass('bm-active');
    $(this).addClass('bm-active');
  });

  // choose random product slide
  // var bmRandomSlide = Math.floor(Math.random() * 3);
  // var bmActiveTitle = bmRandomSlide + 1;
  // $('.productCrousel').slick('slickGoTo', bmRandomSlide);
  // $('.bm-store-wraper>h2:nth-child(' + bmActiveTitle + ')').addClass('bm-active');

  // 
  $('.bm-product-carousel  .wrapper.section--wrapper').on('afterChange', function(event, slick, currentSlide, nextSlide) {
    var bmActiveTitle = parseInt(currentSlide) + 1;
    $('.bm-store-wraper>h2').removeClass('bm-active');
    $('.bm-store-wraper>h2:nth-child(' + bmActiveTitle + ')').addClass('bm-active');
  });

  // variety pack carousel
  $('.bm-section-store .bm-product-media-slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrow: true,
    adaptiveHeight: true
  });

  // but-why carousel
  $('.bmtopcrous').slick({
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    fade: true
  });

  // who-what carousel
  $('.bmcrousels-bm').slick({
    autoplay: true,
    autoplaySpeed: 3000,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    speed: 1000,
    arrow: true,
    adaptiveHeight: false,
    fade: true,
    prevArrow: '<button type="button" class="slick-prev"></button>',
    nextArrow: '<button type="button" class="slick-next"></button>'
  });
  
  $('body').on('click', '.bm-ww-prev', function() {
    $('.bmcrousels-bm .slick-prev').click();
  });

  $('body').on('click', '.bm-ww-next', function() {
    $('.bmcrousels-bm .slick-next').click();
  });

  // recipe carousel
  $('.bmrecipy-crousel .bmrecpieimg').slick({
    dots: false,
    infinite: true,
    speed: 1000,
    /*adaptiveHeight: true,*/
    slidesToShow: 3,
    slidesToScroll: 3,
    /*infinite: false,*/
    responsive: [{
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }]
  });

  $('.bmmaintrust').slick({
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    adaptiveHeight: true
  });
  
  $('#email_signup #Subscribe span').append('<svg class="icon icon-arrow-right icon--baseline"><use xlink:href="#icon-arrow-right"></use></svg>');
  
  var bmQuantityVP =''+ 
    '  <div class="bm-vp-quantity">'+ 
    '      <select tabindex="-1">'+ 
    '      <option value="1">1</option>'+ 
    '      <option value="2">2</option>'+ 
    '      <option value="3">3</option>'+ 
    '      <option value="4">4</option>'+ 
    '      <option value="5">5</option>'+ 
    '      <option value="6">6</option>'+ 
    '      <option value="7">7</option>'+ 
    '      <option value="8">8</option>'+ 
    '      <option value="9">9</option>'+ 
    '      <option value="10">10</option>'+ 
    '    </select>'+ 
    '  </div>';
  $('.bm-section-store .cta-content').before(bmQuantityVP);
  
  $('body').on('change', '.bm-vp-quantity select', function() {
    $(this).parents('.product-single').find('input[name="quantity"]').val($(this).val());
  });

});
